export default __webpack_public_path__ + "static/media/GetitonIcon.404c96ab.png";